import React from 'react'
import PageBlocks from '../../cms-page-blocks/list'

const SessionSaleRegistrationBlocks = (props) => {
  const { sessionSaleId } = props.params

  return (
    <PageBlocks
      title='Session Sale Registration Page Blocks'
      target='session_sale_page_blocks'
      cmsPageProp='session_sale_id'
      cmsPageId={sessionSaleId}
      route={props.route}
    />
  )
}

export default SessionSaleRegistrationBlocks
